import { render, staticRenderFns } from "./InstantCampaignMetrics.vue?vue&type=template&id=6ff8ae08&scoped=true"
import script from "./InstantCampaignMetrics.vue?vue&type=script&lang=js"
export * from "./InstantCampaignMetrics.vue?vue&type=script&lang=js"
import style0 from "./InstantCampaignMetrics.vue?vue&type=style&index=0&id=6ff8ae08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ff8ae08",
  null
  
)

export default component.exports